import * as React from 'react';
import { AppErrorBoundary } from '@helpcenter/error-boundary';
import type { WrappedComponentProps, MessageDescriptor } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import SectionMessage from '@atlaskit/section-message';

import messages from './messages';

type ErrorBoundaryMessageType = 'field' | 'comment' | 'comment-editor';

interface ErrorBoundarySectionMessageProps {
    type: ErrorBoundaryMessageType;
}

export const ErrorBoundarySectionMessage = injectIntl(
    ({ type, intl }: ErrorBoundarySectionMessageProps & WrappedComponentProps) => (
        <SectionMessage appearance="error">{intl.formatMessage(typeToMessage(type))}</SectionMessage>
    )
);

const typeToMessage = (type: ErrorBoundaryMessageType): MessageDescriptor => {
    if (type === 'field') {
        return messages.failedToRenderField;
    }
    if (type === 'comment') {
        return messages.failedToRenderComment;
    }
    if (type === 'comment-editor') {
        return messages.failedToRenderCommentEditor;
    }
    return messages.unknownError;
};

export interface ErrorBoundaryMessageProps {
    type: ErrorBoundaryMessageType;
    children: React.ReactElement;
}

const ErrorBoundaryMessage = ({ type, children }: ErrorBoundaryMessageProps) => {
    const renderError = React.useCallback(() => <ErrorBoundarySectionMessage type={type} />, [type]);
    return <AppErrorBoundary renderError={renderError}>{children}</AppErrorBoundary>;
};

export default ErrorBoundaryMessage;
